module.exports = __webpack_public_path__ + "static/img/banner.5af9db6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/magic/banner.jpg
// module id = nSqC
// module chunks = 0